import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { LegalFormDto } from '@/modules/counterparty/dto/legal-form.dto.ts';
import type { LegalForm } from '@/modules/counterparty/types/legal-form.type.ts';

export class LegalFormAdapter {
  private static map(response: LegalFormDto): LegalForm {
    return {
      id: response.LF_ID,
      name: response.ПФ,
    };
  }

  static mapList(response: ItemsDto<LegalFormDto>) {
    return response.items.map(LegalFormAdapter.map);
  }
}
